var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({staticClass:"ui-navigation-button",class:{ active: _vm.active, disabled: _vm.disabled },attrs:{"type":"button","disabled":_vm.disabled,"aria-current":_vm.active ? 'page' : null}},'button',_vm.$attrs,false),_vm.$listeners),[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }